<template>
  <div class="block" style="height: calc(100vh - 50px);">
    <div>

    </div>
    <van-grid>
      <swipe-image/>
    </van-grid>
    <van-grid clickable :column-num="2" icon-size="32" class="gridwarp" v-if="showCang">
      <!--<van-grid-item icon="search" text="质保书查询" to="/Home/WarrantyBook" />-->
        <van-grid-item icon="https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/orderlist.png" text="派车计划"
                       to="/Home/OrderPlanList"/>
      <van-grid-item icon="https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/kcsearch.png" text="库存查询"
                     to="/Home/InstockCurSel"/>
      <van-grid-item icon="https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/rkserch.png" text="入库查询"
                     to="/Home/InstockSel"/>
      <van-grid-item icon="https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/cksearch.png" text="出库查询"
                     to="/Home/InstockOutSel"/>
      <van-grid-item icon="https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/ghsearch.png" text="过户查询"
                     to="/Home/InstockTranSel"/>
<!--      <van-grid-item icon="https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/ghsearch.png" text="新闻动态"-->
<!--                     to="/Home/NewsList"/>-->
<!--      <van-grid-item icon="https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/ghsearch.png" text="行情资讯"-->
<!--                     to="/Home/SummaryList"/>-->
<!--      <van-grid-item icon="https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/ghsearch.png" text="关于我们"-->
<!--                     to="/Home/AboutUs"/>-->
      <!--<van-grid-item icon="search" text="仓库查询" url="/" />-->
    </van-grid>
    <van-grid clickable :column-num="2" icon-size="32" class="gridwarp" v-if="showProcess">
      <van-grid-item icon="https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/kcsearch.png" text="库存查询"
                     to="/Home/jgCurStockSel"/>
      <van-grid-item icon="https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/rkserch.png" text="入库查询"
                     to="/Home/jgInstockSel"/>
      <van-grid-item icon="https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/cksearch.png" text="出库查询"
                     to="/Home/jgOutstockSel"/>
      <van-grid-item icon="https://dzycsys-1258740428.cos.ap-shanghai.myqcloud.com/img/jgsearch.png" text="加工查询"
                     to="/Home/jgProcessSel"/>
    </van-grid>
  </div>
</template>

<script>
import SwipeImage from "../components/SwipeSearchImage";
import {Grid, GridItem} from 'vant';

export default {
  name: "Search",
  components: {
    SwipeImage: SwipeImage,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem
  },
  data() {
    return {
      showCang: false,
      showProcess: false,
    }
  },
  mounted() {
    let systemId = localStorage.getItem('systemId')
    if (systemId == 10) {
      // 仓库
      this.showCang = true
    } else if (systemId == 15) {
      // 加工
      this.showProcess = true
    }
  }
}
</script>

<style scoped>
.block {
  top: 0px;
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.gridwarp {
  width: 95%;
  margin: 10px auto 0 auto;
  background: #ffffff;
  border-radius: 10px;
  color: #6685a4;
}

/deep/ .van-grid-item__content {
  border-radius: 10px;
}

/deep/ .van-grid-item__text {
  font-size: 14px;
}
</style>
